import { render } from "./Shop.vue?vue&type=template&id=bb4d9172&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"

import "./Shop.vue?vue&type=style&index=0&id=bb4d9172&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Lineage-2-Vue-JS-3-Frontend/Lineage-2-Vue-JS-3-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb4d9172"]])

export default __exports__